import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import { getGiftCardSecureTokenLookup } from 'redux/user/user.actions';
import { Box } from '@mui/material';
import { VerticalDivider } from '../giftcard-details/giftcard-details.styles';
import DetailView from '../giftcard-details/detail-view/detail-view.component';
import { useTranslation } from 'react-i18next';
import GiftcardViewWrapper from '../giftcard-view-wrapper/giftcard-view-wrapper.component';
import GiftcardBalance from '../giftcard-details/giftcard-balance/giftcard-balance.component';

const GiftcardSecureViewPage = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [giftcard, setGiftcard] = useState({});
  const { cardAccountBalance, securityCodeEnabled, maskedCardIdentifier } =
    giftcard;

  useEffect(() => {
    dispatch(getGiftCardSecureTokenLookup(token)).then(response => {
      setIsLoading(false);
      response?.data && setGiftcard(response.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GiftcardViewWrapper
      isLoading={isLoading}
      giftcard={{ ...giftcard, ...state }}
    >
      <Box textAlign="center">
        <GiftcardBalance cardAccountBalance={cardAccountBalance} />
      </Box>
      <Box
        mb={2}
        display="flex"
        justifyContent="space-between"
        flexDirection="row"
      >
        <DetailView
          label={t('eGiftCard.view.cardNumber')}
          detail={
            maskedCardIdentifier ? `**** **** **** ${maskedCardIdentifier}` : ''
          }
          testId="GiftcardSecureViewPage.CardIdentifier"
        />
        {securityCodeEnabled ? (
          <>
            <VerticalDivider orientation="vertical" flexItem />
            <DetailView
              label={t('eGiftCard.view.securityCode')}
              detail="****"
              testId="GiftcardSecureViewPage.SecurityCode"
              noBreak
            />
          </>
        ) : (
          <></>
        )}
      </Box>
    </GiftcardViewWrapper>
  );
};

export default GiftcardSecureViewPage;
